import type { TenantResponse } from 'services/TenantService';

/**
 * Whether the first-run onboarding flow should be shown instead of the app.
 *
 * Only a tenant created by a user signing themselves up starts with incomplete onboarding state,
 * so any other tenant - one that predates the flow, or that was provisioned for its users - is
 * never onboarded no matter who signs in.
 *
 * It is also limited to tenant administrators. The flow renames the tenant, which only an
 * administrator may do, so showing it to anyone else would walk them into a step they cannot
 * complete. In practice that means the user who signed up, who is made an administrator because
 * their tenant has no others, and any administrator added before they finished.
 *
 * SquaredUp administrators are never shown it, even though they count as administrators of every
 * tenant.
 */
export const shouldShowOnboarding = (
    tenant: TenantResponse | undefined,
    isSquaredUpAdministrator: boolean
): boolean => {
    if (!tenant?.onboarding || tenant.onboarding.completedAt || isSquaredUpAdministrator) {
        return false;
    }

    return tenant.callerPermissions?.includes('AD') === true;
};
